import React from "react";

import Layout from "../components/layout/Layout";
import SEO from "../components/SEO";
import Article from "../components/layout/Article";

const AboutPage = () => (
  <Layout sidebar={{ recentPosts: true, search: true }}>
    <SEO title="About" />
    <Article title="About Us">
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto, nobis
        suscipit mollitia fugit dolores praesentium odit facilis cumque earum
        magni commodi. Atque, velit consectetur? Esse, perferendis, voluptatibus
        sunt rem, voluptates quis ab molestias delectus adipisci minus porro aut
        excepturi ducimus.
      </p>
    </Article>
  </Layout>
);

export default AboutPage;
